import React, {useState, useEffect} from 'react';
import {Grid} from '@material-ui/core/';
import { useStyles } from "./style";
import {connect } from "react-redux";
import mapStateToProps from './mapStateToProps';
import mapDispatchToProps from './mapDispatchToProps';
import ApiServices from 'services/ApiServices';
import Searcher from './searcher/searcher';
import ResponseElement from 'components/ResponseElement';
import DatosGeneralesCiudadano from './datosGeneralesCiudadano';
import LoadingSpinner from 'components/LoadingSpinner';
import { showMessageErrorSimple, showMessagePersonalizedPosition } from 'services/SweetAlert';
import DialogLoadingMessage from 'components/BackDrop';

function CitizenIdentityData(props) {
    const classes = useStyles(),
        [apiErrors,setApiErrors] = useState([]);
    const [loadingMessage, setLoadingMessage] = useState({loading:false, title:''});
    const [responseData, setResponseData] = useState({ errorType: 'error',  messageType: '', openResponse: false });
    const [mostrarDatosCiudadanoTSE, setMostrarDatosCiudadanoTSE] = useState(false);
    const [loadingRequest, setLoadingRequest] = useState(false);
    let datosDelCiudadano = {}, positionComunidad='';

    useEffect( () => {
        if(props.datosSolicitudExtranjero.primerNombre && props.datosSolicitudExtranjero.primerApellido || props.datosSolicitudExtranjero.nroBoleta) {
            props.SET_DATA_IS_REGISTERED(true);
            setMostrarDatosCiudadanoTSE(true);
        }
        // console.log("props.citaEnProceso en CitizenIdentityData:", props.citaEnProceso);
    }, []);

    //abrimos el modal para aprobar solicitudes de empadronamiento
    const validarIdentidadDelCiudadano = async (cui) => {
        setLoadingMessage({loading: true, title:'Obteniendo información ...'})
        props.SET_DATA_IS_REGISTERED({});
        setMostrarDatosCiudadanoTSE(false);
        props.CLEAR_PROFILE_IMG()
        props.SET_CUI_CITIZEN('')
        try{
            let response = await ApiServices.consultarRegistrosDeEmpadronamientoYRenap.customGET(`list`, {key: "cui", value: Number(cui)});
            // console.log('informacion obtenida: ', response.data)
            props.SOLICITUD_EMPADRONAMIENTO_SET_ES_PADRON_RENAP(response.data.existeInformacion)
            props.CLEAR_DATA_DATOS_IDENTIDAD_DEL_CIUDADANO();
            props.CLEAR_DATA_DATOS_IDENTIDAD();

            if(!response.error){
                setLoadingMessage({loading: false, title:''})
                validarIdentidad(cui)
                if(response.data.nroBoleta) {
                    props.SOLICITUD_EMPADRONAMIENTO_SET_IS_INSCRIPCION_ACTUALIZACION('ACTUALIZACIÓN DE DATOS')
                    datosDelCiudadano = response.data
                    // await setComunidad(response.data)
                    // obtenerCiudadDelEstadoDelPais(response.data)
                    props.SET_DATA_DATOS_IDENTIDAD_DEL_CIUDADANO(datosDelCiudadano);
                    setMostrarDatosCiudadanoTSE(true);
                    props.SET_DATA_IS_REGISTERED(true);                    
                } else {
                    props.SOLICITUD_EMPADRONAMIENTO_SET_IS_INSCRIPCION_ACTUALIZACION('NUEVA INSCRIPCIÓN')
                    props.SET_DATA_DATOS_IDENTIDAD_DEL_CIUDADANO_NO_EMPADRONADO(response.data);
                    setMostrarDatosCiudadanoTSE(true);
                    props.SET_DATA_IS_REGISTERED(true);
                }
            } else {
                if(!response.error?.code || Number(response.error?.code) === 390) {
                    showMessagePersonalizedPosition('warning', '¡Advertencia! ',response?.error?.message, 'center')
                }

                setMostrarDatosCiudadanoTSE(true);
                props.SET_CUI_CITIZEN(cui)
                props.SET_DATA_IS_REGISTERED(false);
                showMessagePersonalizedPosition('warning', '¡Advertencia! ',response?.error?.message, 'center')
                setLoadingMessage({loading: false, title:''})
                // setResponseData({ errorType: 'error', messageType: 'Oops! '+response?.error?.message,  openResponse: true, });
            }

        } catch(exception){
            setMostrarDatosCiudadanoTSE(true);
            props.SET_DATA_IS_REGISTERED(false);
            if (exception.status===404) {
                showMessagePersonalizedPosition('error', '¡Advertencia!', "Intente de nuevo. Ponganse en contacto con el Administrador sí este mensaje persiste.", 'center')
            }
            else {
                showMessagePersonalizedPosition('error', '¡Advertencia!', "Intente de nuevo. Ponganse en contacto con el Administrador sí este mensaje persiste.", 'center')
            }
            setLoadingMessage({loading: false, title:''})
        }
    }

    //cargamos las comunidades en base al municipio seleccionado
    const setComunidad =async (datos)=>{
        setLoadingRequest(true)
        try{
            ApiServices.comunidades.searchCriteria.clear();
            ApiServices.comunidades.searchCriteria.setOperator("and");
            ApiServices.comunidades.searchCriteria.addEquals("departamentoId", datos.comunidadResidencia.departamentoId);
            ApiServices.comunidades.searchCriteria.addEquals("municipioId",datos.comunidadResidencia.municipioId);
            let response =await ApiServices.comunidades.listRegisterCriteria();
            setLoadingRequest(false)
            if(response.error){
            }else {

                var comunidades = response.data
                Object.keys(comunidades).forEach((element, key, _array) =>{
                    if(comunidades[element].id === datos.comunidadResidencia.id){
                        positionComunidad = element
                        datosDelCiudadano.positionComunidad = element
                    }
                })
            }
        }catch(exception){
            setLoadingRequest(false)
        }
    };
    const obtenerCiudadDelEstadoDelPais =async (datos)=>{
        try{
            ApiServices.ciudades.searchCriteria.clear();
            ApiServices.ciudades.searchCriteria.setOperator("and");
            ApiServices.ciudades.searchCriteria.addEquals("paisId", datos.datosresidenciaEnELExtranjero.paisId);
            ApiServices.ciudades.searchCriteria.addEquals("estadoId",datos.datosresidenciaEnELExtranjero.estadoId);
            let response =await ApiServices.ciudades.listRegisterCriteria();
            if(response.error){
            }else {
                    var ciudades = response.data
                    Object.keys(ciudades).forEach((element, key, _array) =>{
                        if(ciudades[element].id === datos.datosresidenciaEnELExtranjero.ciudadId){
                            datosDelCiudadano = {...datosDelCiudadano, posicionCiudad: element}
                        }
                    })
                }
        }catch(exception){
        }
        props.SET_DATA_DATOS_IDENTIDAD_DEL_CIUDADANO(datosDelCiudadano);
        setMostrarDatosCiudadanoTSE(true);
        props.SET_DATA_IS_REGISTERED(true);
    };
    const validarIdentidad = async (cui) => {
        setLoadingMessage({loading: true, title:'Obteniendo imágenes ...'})
        try{
            const response =  await ApiServices.verificarSolicitudDeEmpadronamiento.validarIdentidad(cui);

            if(response.error){
                if(response.error.code==302) {
                    setResponseData({  errorType: 'error', messageType: `¡Oops! ${response.error.message}`, openResponse: true, })
                    return;
                }
                setResponseData({  errorType: 'error', messageType: '¡Oops! Error al obtener los datos del usuario. Foto, Huella, Firma',  openResponse: true,  });
            }else {
                props.SET_DATA_DATOS_IDENTIDAD(response?.data?.object)
            }
        }catch(exception){
            if (exception.status===404) {
                showMessagePersonalizedPosition('error', '¡Advertencia!', "Intente de nuevo. Ponganse en contacto con el Administrador sí este mensaje persiste.", 'center')
            }
            else {
                showMessagePersonalizedPosition('error', '¡Advertencia!', "Intente de nuevo. Ponganse en contacto con el Administrador sí este mensaje persiste.", 'center')
            }
        }
        setLoadingMessage({loading: false, title:''})
    }


    const handCloseResponseData = () => {
        setResponseData({
            errorType: 'error',
            messageType: "",
            openResponse: false,
        });
    };

    const cancelAndCloseDialog = () => {
        setResponseData({  errorType: 'error', messageType: "", openResponse: false, })
        setMostrarDatosCiudadanoTSE(false);
        props.cerrarDialogo();
        props.CLEAR_DATA_DATOS_IDENTIDAD();
        props.CLEAR_DATA_DATOS_IDENTIDAD_DEL_CIUDADANO();
        props.SET_DATA_IS_REGISTERED({});
    }

    const { errorType, messageType, openResponse} = responseData;

    return (
        <div className={classes.root}>
            <DialogLoadingMessage open={loadingMessage.loading} title={loadingMessage.title}/>
            <LoadingSpinner open={loadingRequest} message="Buscando, Espere un momento por favor!"/>
            <ResponseElement type={errorType} content={messageType} open={openResponse} handClose={handCloseResponseData} />
            <div className={classes.colorComponente}>
                <Grid >
                    <Grid className={classes.marginText} item xs={12} >
                        <Searcher validarIdentidadDelCiudadano={validarIdentidadDelCiudadano} citaEnProceso = {props.citaEnProceso} />
                    </Grid>
                </Grid>
                {mostrarDatosCiudadanoTSE && (
                    <>
                        <Grid >
                            <Grid className={classes.marginText} item xs={12} >
                                <DatosGeneralesCiudadano {...props} cerrarDialogo={cancelAndCloseDialog}/>
                            </Grid>
                        </Grid><br/>
                        <div className={classes.lineaDegradadaBottom}></div>
                    </>
                )}
            </div> <br/>
        </div>
    );
}


export default connect(mapStateToProps, mapDispatchToProps)(CitizenIdentityData);